export default [
  {
    path: '/report/daily-closeout',
    name: 'report-daily-closeout',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  }
]
